var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#256CE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8232 20.4318C30.8382 20.8401 31.4682 22.0418 31.2349 23.1035L30.7565 25.2734C29.9282 29.0068 26.9999 31.6668 22.7765 31.6668H17.2232C12.9999 31.6668 10.0715 29.0068 9.2432 25.2734L8.76486 23.1035C8.53153 22.0418 9.16152 20.8401 10.1765 20.4318L11.8332 19.7668L18.2615 17.1885C19.3815 16.7451 20.6182 16.7451 21.7382 17.1885L28.1665 19.7668L29.8232 20.4318Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.6665V17.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1668 15.3335V19.7668L21.7385 17.1885C20.6185 16.7452 19.3818 16.7452 18.2618 17.1885L11.8335 19.7668V15.3335C11.8335 13.4085 13.4085 11.8335 15.3335 11.8335H24.6668C26.5918 11.8335 28.1668 13.4085 28.1668 15.3335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9168 11.8335H17.0835V9.50016C17.0835 8.8585 17.6085 8.3335 18.2502 8.3335H21.7502C22.3918 8.3335 22.9168 8.8585 22.9168 9.50016V11.8335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2cef8ff9151834b8c1a7897c077e1ee4.svg";
export { ForwardRef as ReactComponent };